import styled, { css } from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';

import { device, typography } from '@/styles/helpers';

const characterImage = getCDNImageUrl('/quest-xmas/character.webp');
const characterMobileImage = getCDNImageUrl(
  '/quest-xmas/character-mobile.webp'
);

export const ScDailyBlock = styled.div<{ isAuthenticated: boolean }>`
  margin-top: 230px;
  margin-bottom: ${({ isAuthenticated }) =>
    isAuthenticated ? '194px' : '110px'};
  position: relative;
  z-index: 3;

  .daily-logo {
    width: 150px;
    display: block;
    margin: 0 auto 32px;
  }
  .missions-wrapp {
    position: relative;
    margin: 0 auto;
    padding: 24px;
    border-radius: 12px;
    max-width: 771px;

    border: 1px solid #c5b5a0;
    border-top-width: 3px;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px 11.5px;
    @media (${device.mobile}) {
      gap: 8px 26px;
      padding: 24px 12px;
    }
    @media (max-width: 365px) {
      gap: 8px 16px;
    }

    &::before {
      content: '';
      position: absolute;
      top: -300px;
      width: 650px;
      height: 473px;
      background-image: url(${characterImage});
      background-size: cover;
      background-position: center;
      z-index: -1;

      @media (${device.mobile}) {
        top: -160px;
        width: 326px;
        height: 258px;
        background-image: url(${characterMobileImage});
      }
    }

    &::after {
      background-color: rgba(131, 199, 239, 0.5);
      content: '';
      position: absolute;
      inset: 0;
      backdrop-filter: blur(18px);
      z-index: -1;
    }

    & .top {
      position: absolute;
      height: 95px;
      width: 105%;
      top: -40px;
      left: 0px;
      @media (${device.mobile}) {
        height: 53px;
        width: 95%;
        top: -26px;
        left: 10px;
      }
    }
    & .bottom {
      position: absolute;
      height: 180px;
      width: 105%;
      left: -40px;
      bottom: -95px;
      @media (${device.mobile}) {
        height: 53px;
        width: 95%;
        left: 10px;
        bottom: -26px;
      }
    }
  }

  & .regButton {
    margin: 0 auto;
    margin-top: 32px;
    max-width: 280px;
  }

  @media (${device.mobile}) {
    padding: 24px;
    margin-top: 122px;
  }
  @media (max-width: 365px) {
    padding: 8px;
  }
`;

export const ScFaq = styled.div`
  position: relative;
  background: #072741;

  .content {
    max-width: 862px;
    margin-inline: auto;
    padding: 0px 16px 112px;

    @media (${device.mobile}) {
      padding: 0px 16px 64px;
    }

    h3 {
      ${typography['headline1']}
      text-align: center;
      text-transform: uppercase;
      color: ${({ theme }) => theme.whiteColor};
      margin-bottom: 24px;
    }
  }

  .questions-wrapp {
    & > div {
      background-color: ${({ theme }) => theme.gray1Color};
      margin-top: 8px;
      .answer::after {
        content: '';
        display: block;
        height: 16px;
      }
    }
  }

  .faq-item {
    background: rgba(9, 26, 50, 0.6);
    position: relative;
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    display: block;
    width: 100%;
    height: 60px;
    bottom: -20px;
    z-index: 1;
    background-color: ${({ theme }) => theme.blackColor};
  }

  .assets {
    .decorationContainer {
      bottom: -130px;
      height: 260px;
      width: 100%;
      position: absolute;
      z-index: 10;

      @media (${device.mobile}) {
        height: 125px;
        bottom: -55px;
      }

      img {
        position: relative;
      }
    }
  }
`;

export const ScTerms = styled.div<{ isAuthenticated: boolean }>`
  background-color: ${({ theme }) => theme.blackColor};
  border-radius: 24px 24px 0 0;
  overflow-x: hidden;
  z-index: 3;
  position: relative;

  ${({ isAuthenticated }) =>
    !isAuthenticated &&
    css`
      padding: 24px 0;
    `};
  .content {
    max-width: 1137px;
    margin-inline: auto;
    padding: 64px 16px 16px;
    z-index: 1;
    h3 {
      font-weight: 700;
      font-size: 22px;
      line-height: 28px;
      text-align: center;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: ${({ theme }) => theme.whiteColor};
      margin-bottom: 16px;

      @media (${device.mobile}) {
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 16px;
      }
    }
    ol {
      list-style-position: inside;
      li {
        font-size: 16px;
        line-height: 24px;
        color: ${({ theme }) => theme.blackLightColor};
        margin-top: 24px;
      }
    }
  }

  .assets {
    .animation {
      position: absolute;
      opacity: 0.2;
    }
  }
`;

export const ScQuestPage = styled.div`
  .title {
    text-align: center;
    ${typography['headline1']}
    @media (${device.mobile}) {
      ${typography['headline2mobile']}
    }
  }
  .description {
    text-align: center;
    margin-bottom: 0;
    ${typography['body2regular']}
    max-width: 450px;
    color: ${({ theme }) => theme.whiteColor};
  }
`;

export const ScQuestHeader = styled.div`
  position: relative;
  margin-top: -48px;
  padding-top: 48px;
  overflow: hidden;

  @media (${device.mobile}) {
    margin-top: -64px;
    padding-top: 48px;
  }
  & .bonuses-notice-box {
    margin-block: -16px 16px;
    width: min(480px, 100%);
    margin-inline: auto;

    &:empty {
      display: none;
      margin: 0;
    }
  }

  & .content {
    z-index: 5;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;

    @media (${device.mobile}) {
      gap: 4px;
      & .quest-img {
        width: 272px;
        height: 173px;
      }
    }
  }

  & > .time-clock {
    margin-bottom: 16px;
    margin-top: 32px;
    display: flex;
    justify-content: center;
    span {
      color: ${({ theme }) => theme.blackColor};
    }
    @media (${device.mobile}) {
      margin-bottom: 12px;
      margin-top: 68px;
    }
  }
`;

export const ScQuestHeaderAssets = styled.div`
  display: flex;
  justify-content: center;

  & > img:not(.mobile) {
    position: absolute;
  }

  & > .bg {
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    z-index: -1;
  }

  & > .static {
    z-index: 2;
    bottom: 0;
    &.left {
      left: 0px;
      @media (${device.mobile}) {
        display: none;
      }
    }
    &.right {
      right: 0px;
      @media (${device.mobile}) {
        display: none;
      }
    }

    &.mobile {
      position: absolute;
      display: none;
      width: 100%;
      height: auto;
      @media (${device.mobile}) {
        display: block;
      }
    }
  }

  & > .bg-animation {
    z-index: 1;
    position: absolute;
    bottom: -16px;
    display: flex;
    @media (${device.mobile}) {
      display: none;
    }
    .left {
    }
    .right {
      transform: rotateY(180deg);
    }
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    display: block;
    background: linear-gradient(0deg, #072741 0%, rgba(0, 1, 5, 0) 100%);
    width: 100%;
    height: 64px;
    z-index: 3;
  }
`;

export const ScQuestContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 64px;
  padding: 0 0 24px;

  @media (${device.mobile}) {
    padding-top: 8px;
  }
`;
